// extracted by mini-css-extract-plugin
module.exports = {"headline":"Headline__headline--32KDc","bounce":"Headline__bounce--35Rof"};